import React from 'react';

const INPUT_CLASSES =
  'px-[10px] py-[7px] bg-surface-base text-surface-text border border-surface-border text-xs focus:outline-none focus:ring-2 focus:ring-accent rounded-[2px]';

/**
 * Filter row for the Accounts tab.
 * Props:
 *   - search, onSearchChange
 *   - banFilter, onBanFilterChange
 *   - accountTypeFilter, onAccountTypeFilterChange (hidden for non-managers)
 *   - cs2Filter, onCs2FilterChange
 *   - pageSize, onPageSizeChange
 *   - role
 */
export default function FilterRow({
  search, onSearchChange,
  banFilter, onBanFilterChange,
  accountTypeFilter, onAccountTypeFilterChange,
  cs2Filter, onCs2FilterChange,
  pageSize, onPageSizeChange,
  role
}) {
  return (
    <div className="flex gap-2 mb-3 items-center">
      <input
        type="text"
        placeholder="Search by name, SteamID, username…"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className={`flex-1 ${INPUT_CLASSES}`}
      />
      <select value={banFilter} onChange={(e) => onBanFilterChange(e.target.value)} className={INPUT_CLASSES}>
        <option value="all">Ban: All</option>
        <option value="banned">Only banned</option>
        <option value="unbanned">Only unbanned</option>
      </select>
      {(role === 'manager' || role === 'user') && (
        <select value={accountTypeFilter} onChange={(e) => onAccountTypeFilterChange(e.target.value)} className={INPUT_CLASSES}>
          <option value="all">Type: All</option>
          <option value="credentialed">Credentialed</option>
          <option value="monitored">Monitored</option>
        </select>
      )}
      <select value={cs2Filter} onChange={(e) => onCs2FilterChange(e.target.value)} className={INPUT_CLASSES}>
        <option value="all">CS2: All</option>
        <option value="ready">Ready</option>
        <option value="cooldown">In cooldown</option>
        <option value="login_error">Login error</option>
        <option value="quarantined">Quarantined</option>
        <option value="pending">Pending</option>
        <option value="not_tracked">Not tracked</option>
      </select>
      <select value={pageSize} onChange={(e) => onPageSizeChange(Number(e.target.value))} className={INPUT_CLASSES}>
        {[10, 20, 50, 100].map((n) => <option key={n} value={n}>{n} / page</option>)}
      </select>
    </div>
  );
}
